/**
 * Ad-landing coupons: a link like /brand/sonyliv?coupon=WEB200 carries a
 * code that checkout validates and applies by itself. Prices are untouched;
 * the code is an ordinary DiscountCoupon, so the backend decides validity,
 * amount and usage limits, and every order that used it is countable by code.
 */

const STORAGE_KEY = 'fleek_link_coupon';
const PARAMS = ['coupon', 'promo'];
const MAX_AGE_MS = 7 * 24 * 60 * 60 * 1000;
const CODE_PATTERN = /^[A-Z0-9_-]{3,32}$/;

const normalise = (raw) => String(raw || '').trim().toUpperCase();

/** On landing: the latest valid-looking code wins. */
export const captureLinkCoupon = (search = window.location.search) => {
  try {
    const params = new URLSearchParams(search);
    const param = PARAMS.find((p) => params.get(p));
    if (!param) return null;
    const code = normalise(params.get(param));
    if (!CODE_PATTERN.test(code)) return null;
    const saved = { code, captured_at: Date.now(), landing_path: window.location.pathname };
    localStorage.setItem(STORAGE_KEY, JSON.stringify(saved));
    return saved;
  } catch (e) {
    return null;
  }
};

/** The saved code, or null once it's older than a week. */
export const getLinkCoupon = (now = Date.now()) => {
  try {
    const saved = JSON.parse(localStorage.getItem(STORAGE_KEY) || 'null');
    if (!saved?.code) return null;
    if (now - Number(saved.captured_at || 0) > MAX_AGE_MS) {
      localStorage.removeItem(STORAGE_KEY);
      return null;
    }
    return saved;
  } catch (e) {
    return null;
  }
};

export const clearLinkCoupon = () => {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    /* storage blocked */
  }
};
